/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export let CommitmentUploadStatus = /*#__PURE__*/function (CommitmentUploadStatus) {
  CommitmentUploadStatus["COMPLETED"] = "COMPLETED";
  CommitmentUploadStatus["DEFUALT"] = "DEFAULT";
  CommitmentUploadStatus["UPLOADED"] = "UPLOADED";
  CommitmentUploadStatus["UPLOADING"] = "UPLOADING";
  return CommitmentUploadStatus;
}({});